// Iter42 — Reusable PARITY engine badge.
//
// Shows the WES engine source on any row that displays WES-P/WES-C/VAL/POC/VAH.
// Per the audit (§ 10), rows that aren't backed by Pine Parity Engine v1
// must NOT appear as a normal valid WES row — instead they get a
// distinguishing LGY/ERR/STALE badge that warns the user.
//
// Accepts the engine string + (optional) freshness/scanned_at/source so
// the tooltip can give the operator the full audit context with one hover.

import React from "react";

const STYLES = {
  PARITY: "bg-[#00FF88]/15 text-[#00FF88] border-[#00FF88]/40",
  LGY:    "bg-[#FFB800]/15 text-[#FFB800] border-[#FFB800]/40",
  ERR:    "bg-[#FF3366]/15 text-[#FF3366] border-[#FF3366]/40",
  STALE:  "bg-[#FFB800]/10 text-[#FFB800] border-[#FFB800]/30",
};

const LABEL_FOR = {
  parity_v1: "PARITY",
  parity:    "PARITY",
  legacy:    "LGY",
  err:       "ERR",
};

export function WesEngineBadge({ engine, freshnessState, scannedAt, source, parityValid, testid }) {
  const eng = (engine || "").toLowerCase();
  let label = LABEL_FOR[eng] || "ERR";
  // Parity row that's stale → show STALE in amber, regardless of the
  // parity-valid flag. This matches the audit § 10.1 colour palette.
  if (parityValid && (freshnessState === "STALE" || freshnessState === "OLD")) {
    label = "STALE";
  }
  // Engine claims parity but the parity-valid flag is false → degrade to ERR.
  if ((eng === "parity_v1" || eng === "parity") && parityValid === false) {
    label = "ERR";
  }
  const cls = STYLES[label] || STYLES.ERR;
  const tooltipLines = [
    `WES Engine: ${eng || "unknown"}`,
    source ? `Source: ${source}` : null,
    scannedAt ? `Last scanned: ${new Date(scannedAt).toLocaleString()}` : null,
    freshnessState ? `Freshness: ${freshnessState}` : null,
  ].filter(Boolean);
  return (
    <span
      data-testid={testid || "wes-engine-badge"}
      data-engine={eng}
      data-parity-valid={parityValid ? "true" : "false"}
      title={tooltipLines.join("\n")}
      className={`text-[8px] font-bold tracking-[0.12em] px-1 py-px rounded-sm border flex-shrink-0 ${cls}`}
    >
      {label}
    </span>
  );
}

export default WesEngineBadge;
